var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGasLoad = function SvgGasLoad(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 0.75H1.75C1.19772 0.75 0.75 1.19772 0.75 1.75V22.25C0.75 22.8023 1.19772 23.25 1.75 23.25H14.75C15.3023 23.25 15.75 22.8023 15.75 22.25V1.75C15.75 1.19772 15.3023 0.75 14.75 0.75Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 5.25C12.75 4.85218 12.592 4.47064 12.3107 4.18934C12.0294 3.90804 11.6478 3.75 11.25 3.75H5.25C4.85218 3.75 4.47064 3.90804 4.18934 4.18934C3.90804 4.47064 3.75 4.85218 3.75 5.25C3.75 5.64782 3.90804 6.02936 4.18934 6.31066C4.47064 6.59196 4.85218 6.75 5.25 6.75H11.25C11.6478 6.75 12.0294 6.59196 12.3107 6.31066C12.592 6.02936 12.75 5.64782 12.75 5.25Z",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 9.75H15.75",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 5.25H17.25C17.6478 5.25 18.0294 5.40804 18.3107 5.68934C18.592 5.97064 18.75 6.35218 18.75 6.75V21.75C18.75 22.1478 18.908 22.5294 19.1893 22.8107C19.4706 23.092 19.8522 23.25 20.25 23.25C20.6478 23.25 21.0294 23.092 21.3107 22.8107C21.592 22.5294 21.75 22.1478 21.75 21.75V12.75C21.7499 11.7713 22.0394 10.8145 22.582 10L23.25 9",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12.75H23.25",
    stroke: "#000033",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgGasLoad;